module.exports = __webpack_public_path__ + "static/img/c1.aecc9ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c1.jpg
// module id = a5VM
// module chunks = 1